module.exports = __webpack_public_path__ + "img/cup-of-hope.26dd4125.jpg";